module.exports = __webpack_public_path__ + "img/product-placeholder-48.c0be626.png";